import { CheckCircleIcon, ClockIcon } from '@heroicons/react/20/solid';
import { DateTime } from 'luxon';

export default function DataSourceCard({ source }) {
  return (
    <section className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <h5 className="text-lg font-semibold text-gray-800 mb-2">
        {source.documentation_name}
      </h5>

      <div className="mb-1 text-sm">
        <span className="font-medium text-gray-900">Backfill complete: </span>
        {source.backfill_completed ? (
          <CheckCircleIcon className="inline-block h-5 w-5 text-green-700" />
        ) : (
          <ClockIcon className="inline-block h-5 w-5 text-yellow-500" />
        )}
      </div>

      <div className="mb-1 text-sm">
        <span className="font-medium text-gray-900">Data as of: </span>
        {source.data_as_of
          ? DateTime.fromISO(source.data_as_of).toLocaleString()
          : "Pending"}
      </div>

      <div className="text-sm">
        <span className="font-medium text-gray-900">Last pull: </span>
        {source.data_last_refreshed
          ? DateTime.fromISO(source.data_last_refreshed).toLocaleString(DateTime.DATETIME_MED)
          : "Pending"}
      </div>
    </section>
  );
}
